import React from 'react';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Footer from '../../Common/CommonComponents/Footer';
import ImageFallback, { getFallbackSource } from '../../Common/CommonComponents/ImageFallback';
import DomainCheckHelper from '../../Helpers/DomainCheckHelper';

const useStyles = makeStyles((theme) => ({
  body: {
    background: 'none',
  },
  lostTitle: {
    fontSize: '10rem',
    margin: '20px 0 20px',
    fontWeight: 700,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '8rem',
    },
  },
  verticalImageLayout: {
    width: '20rem',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
      width: '15rem',
    },
  },
  header: {
    position: 'relative',
    padding: '15px 0 25px 0',
    width: '100%',
    height: 'auto',
    textAlign: 'center',
    backgroundColor: '#e8f8fe',
  },
  logo: {
    width: '15%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '30%',
    },
  },
  lostBody: {
    margin: '0 auto',
    maxWidth: '70%',
    maxHeight: '70vh',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      minHeight: 'auto',
      maxHeight: '90vh',
    },
  },
  p1: {
    marginBottom: '1em',
    marginTop: '1em',
    fontSize: 18,
    lineHeight: '1.4em',
    color: 'black',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  p2: {
    marginLeft: '1em',
    fontSize: '1.125em',
    lineHeight: '1.4em',
    color: 'black',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginLeft: 0,
    },
  },
  continueLink: {
    color: '#38445f',
    textDescription: 'none',
  },
  imgFluid: {
    width: '100%',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
      width: '80',
    },
  },
  caption: {
    fontWeight: 600,
    color: '#222C4F',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
  h1Custom: {
    fontSize: 23,
    fontWeight: 300,
  },
}));

const LostPage = function (props) {
  const classes = useStyles();
  const {
    affid, form, variant_number: variantNumber, logo, logoWebp,
  } = props;

  const domain = DomainCheckHelper.checkDomain();

  const formatLink = () => {
    const link = '/';
    let sitePath = '?';
    if (domain === 'life') {
      sitePath = 'life-insure/?';
    } else if (domain === 'homeInsure') {
      sitePath = 'home-insure/?';
    }
    const affiliateParam = +affid ? `affid=${affid}&` : '';
    const formParam = form ? `form=${form}&` : '';
    const variantParam = +variantNumber ? `variant=${variantNumber}` : '';
    return link + sitePath + affiliateParam + formParam + variantParam;
  };

  const formatOttoImage = (extension) => {
    if (domain.indexOf('auto') >= 0) {
      return `${process.env.PUBLIC_URL}/assets/LP/Otto2/Otto_Glasses_Paint_Car_Cropped.${extension}`;
    }
    return `${process.env.PUBLIC_URL}/assets/LP/Otto2/Otto_Glasses.${extension === 'jpg' ? 'png' : extension}`;
  };

  return (
    <div>
      <Grid>
        <div className={classes.header}>
          <img className={classes.logo} src={`https://dq3ll41r32qbq.cloudfront.net${getFallbackSource(logoWebp || logo, logo)}`} alt="Auto Logo" />
        </div>
      </Grid>
      <Grid container alignItems="center" className={classes.lostBody}>
        <Grid item xs={12} md={6} xl={6}>
          <h1 className={classes.lostTitle}>404</h1>
          You must be lost...
          {' '}
          <Link
            to={formatLink()}
            className={classes.continueLink}
          >
            Click here
          </Link>
          {' '}
          to return.
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <ImageFallback
            className={domain === 'autoSavings' ? classes.imgFluid : classes.verticalImageLayout}
            alt="Otto 404 Page"
            fallback={formatOttoImage('jpg')}
            src={formatOttoImage('webp')}
          />
        </Grid>
      </Grid>
      <Grid><Footer {...props} /></Grid>
    </div>
  );
};

LostPage.propTypes = {
  affid: PropTypes.string,
  form: PropTypes.string,
  variant_number: PropTypes.string,
  logo: PropTypes.string,
};

LostPage.defaultProps = {
  logo: '',
  affid: '',
  form: '',
  variant_number: '',
};
export default LostPage;
